import { z } from 'zod';
import { objectIdSchema } from './objectId';
import { TimeSchema } from './time';
import { StaffTemplateSchema } from './staffTemplate';

export const StaffAllocationSchema = z.object({
  _id: objectIdSchema,
  template: StaffTemplateSchema, 
  startTime: z.number(), // In minutes, relative to event start time
  duration: z.number(), // In minutes
  activity: z.string(),
  quantity: z.number(),
});

export const BareStaffAllocationSchema = z.object({
  _id: objectIdSchema,
  template: objectIdSchema,
  startTime: z.number(), // In minutes, relative to event start time
  duration: z.number(), // In minutes
  activity: z.string(),
  quantity: z.number(),
});

export const ReportsStaffAllocationSchema = StaffAllocationSchema.extend({
  eventName: z.string(),
  eventStartTime: TimeSchema,
  eventDuration: z.number(),
  venueName: z.string(),
});

export const StaffWarningSchema = StaffAllocationSchema.extend({
  eventStartTime: TimeSchema,
  eventStartMinutes: z.number(),
  eventName: z.string(),
  eventId: objectIdSchema,
  venueName: z.string(),
});
